import { ORDER_METHODS } from '../../../../../services/exports/Constants';

export default {
  empty_list: 'Niciun produs încă.',
  fields: {
    number: '#',
    image: 'Imagine',
    name: 'Nume',
    external_id: 'Ref {{integration}}',
    price: 'Preț',
    prices: 'Prețuri',
    description: 'Descriere',
    tags: 'Etichete',
    status: 'Stare',
    product_type: 'Tip',
    statuses: {
      good: 'Bun',
      bad: 'Rău',
      medium: 'Mediu',
    },
    product_types: {
      packaged: 'Ambalat',
      prepared: 'Preparat',
    },
  },
  labels: {
    visible: 'Vizibil în meniu',
    hidden: 'Toate ascunse',
  },
  order_method_prices: {
    base: 'De bază',
    [ORDER_METHODS.pickup]: 'Ridicare',
    [ORDER_METHODS.delivery]: 'Livrare',
    [ORDER_METHODS.on_site]: 'Comenzi la masă',
  },
  buttons: {
    delete_products_one: 'Șterge produsul',
    delete_products_few: 'Șterge produsele',
    delete_products_other: 'Șterge produsele',
    add_product: '+ Adaugă produs',
    show_products: 'Afișează produsele',
    hide_products: 'Ascunde produsele',
    add: 'Adaugă',
    edit: 'Editează',
    duplicate: 'Duplică',
    history: 'Istoric',
    delete: 'Șterge',
    delete_all: 'Șterge tot',
  },
  toasts: {
    failed_to_duplicate_category: 'Duplicarea categoriei a eșuat',
    category_duplicated_successfully: 'Categoria a fost duplicată cu succes',
    failed_to_duplicate_product: 'Duplicarea produsului a eșuat',
    product_duplicated_successfully: 'Produsul a fost duplicat cu succes',
    failed_to_delete_variant: 'Ștergerea variantei a eșuat',
    variant_got_deleted: 'Varianta a fost ștearsă',
    something_went_wrong: 'Ceva a mers greșit',
  },
};
